import React from 'react';
import styled from 'styled-components';
import '../../assets/fonts.css';

const LogoContainer = styled.div`
  align-items: baseline; /* Aligne les éléments sur leur ligne de base de texte */
`;

const WeDo = styled.span`
  font-family: var(--font-wedo);
  font-weight: normal;
  line-height: 1;
  padding-right: 0px;
`;

const Dev = styled.span`
  font-family: var(--font-dev);
  font-weight: bold;
  line-height: 1; /* Normalisation des lignes */
  /* Ajustement léger pour l'alignement parfait - à adapter selon les polices réelles */
  position: relative;
  top: 0;
`;

interface WeDoDevLogoProps {
  className?: string;
  weDoColor?: string;
  devColor?: string;
  color?: string; // Fallback color for all parts
  size?: string;
}

const WeDoDevLogo: React.FC<WeDoDevLogoProps> = ({ 
  className, 
  weDoColor,
  devColor,
  color = 'inherit', 
  size = '24px' 
}) => {
  // Use specific colors if provided, otherwise fall back to the general color
  const finalWeDoColor = weDoColor || color;
  const finalDevColor = devColor || color;

  return (
    <LogoContainer className={className} style={{ fontSize: size }}>
      <WeDo style={{ color: finalWeDoColor }}>we do </WeDo>
      <Dev style={{ color: finalDevColor }}>dev.</Dev>
    </LogoContainer>
  );
};

export default WeDoDevLogo;